import { configure } from "@testing-library/dom";
import React from "react";
import styled from "styled-components";
// import desktop_rip from "../images/close_q_desktop_rip.png";
// import mobile_rip from "../images/close_q_mobile_rip.png";

import { fonts, colors, mediaQueries } from "../shared/config";
const { titles, body, credits } = fonts;
const { red, darkGrey, white } = colors;
const { mobile } = mediaQueries;

const Container = styled("div")`
  /* width: 100vw; */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ${mobile} {
    flex-direction: column;
    height: auto;
    width: 80vw;
    margin: 4em auto;
  }
`;

const BodyText = styled("div")`
  display: flex;
  flex-direction: column;

  width: 100%;
  margin-right: 5em;

  ${mobile} {
    width: auto;
    margin: 0;
  }
`;

const Title = styled("text")`
  font-size: 96px;
  text-transform: uppercase;
  margin-left: 20px;
  font-family: ${titles};
  color: ${red};

  ${mobile} {
    font-size: 36px;
  }
`;
const Subheader = styled("text")`
  font-size: 48px;
  text-transform: uppercase;
  margin-left: 30px;
  font-family: ${titles};
  color: ${darkGrey};

  ${mobile} {
    font-size: 24px;
  }
`;
const MainText = styled("text")`
  font-size: 18px;

  font-family: ${body};
  color: ${darkGrey};

  margin-top: 2em;
  margin-left: 30px;
  width: 95%;
  ${mobile} {
    font-size: 14px;
  }
`;

const ImageContent = styled("div")`
  width: 95%;
  flex-direction: column !important;
  ${mobile} {
    width: 95%;
    flex-direction: column;
  }
`;

const Image = styled("img")`
  width: 45%;
  /* margin-right: 10px; */
  
  ${mobile} {
    margin-left: 30px;
    margin: 2em auto;
    width: 55%;
  }
`;

const Credits = styled("text")`
  font-family: ${credits};
  font-size: 12px;
  padding-top: 1em;

  ${mobile} {
    width: 60%;
    margin: auto;
  }
`;



let ContainMe = styled("div")`
width: 100%;
display: flex;
flex-direction: row;
${mobile} {
    flex-direction: column;
  }
`;
export default function CloseQuarters(props) {
  let content = "";
  return (
    <>
      <Container>
        {props.data.map(block=>{
          if (block.type==="header") {
            return (<Title>{block.content}</Title>);
          }
          if (block.type==="subheader") {
            return (<Subheader>{block.content}</Subheader>);
          }
        })} 
        <BodyText>
        {props.data.map(block=>{

          if (block.type==="paragraph") {
            return(<MainText>{block.content}</MainText>)
          }
        })} 
        </BodyText>
        <ImageContent>

        </ImageContent>
          {props.data.map(block=>{
            if (block.type==="image") {
              return(
                <Image src={block.image_link}></Image>
              )
            }
          })}
          
      </Container>
      {/* <Rip_Desktop src={desktop_rip} /> */}
    </>
  );
}
